<template>
    <div class="order-details" id="subOutputRank-print1">
        <div class="loading" style="text-align: center">
            <Loading :isLoading="isLoading"></Loading>
        </div>
        <div class="order-details-in" v-if="!isLoading">
            <div class="left">
                <div class="state">
                    <div>
                    	<div class="to-print-btn" @click="printBtn" v-if="!isPrint">
                            <i class="iconfont icon-print"></i> 打印预订单
                        </div>
                        <!-- <img :src="qr" alt="" class="logo-od-qr" /> -->
                        <div class="logo">
                            <img src="../../assets/img/cnbookinglog.png" height="39" width="100" style="margin-right: 10px"/>
                            <img src="../../assets/img/logo-cn.png" height="36" width="161"/>
                        </div>
                    </div>
                    <div class="link"></div>
                    <div class="info">

                        <div class="orderNo" style="display:flex">
                            <div class="icon-box" >
                                <i class="iconfont icon-yudingdan"></i>
                            </div>
                            <div >
                                <span class="til">订单号</span><br>
                                <span class="info">{{OrderDetailsList.QGOrderNo}}</span>
                            </div>
                        </div>
                        <div class="orderNo">
                            <span class="til">订单总价</span><br>
                            <span class="info">{{OrderDetailsList.Currency}}{{OrderDetailsList.TotalAmount}}</span>
                        </div>
                        <div class="order-state" v-if="OrderDetailsList.PackageType==1">
                            <span class="til">订单状态</span><br>
                            <span class="info" v-if="OrderDetailsList.Status == 10&&OrderDetailsList.NeedPay">等待付款</span>
                            <span class="info" v-if="OrderDetailsList.Status == 10&&!OrderDetailsList.NeedPay">等待确认</span>
                            <span class="info" v-if="OrderDetailsList.Status == 11&&OrderDetailsList.NeedPay">等待付款</span>
                            <span class="info" v-if="OrderDetailsList.Status == 11&&!OrderDetailsList.NeedPay">等待确认</span>
                            <span class="info" v-if="OrderDetailsList.Status == 20">已确认</span>
                            <span class="info" v-if="OrderDetailsList.Status == 40">已使用</span>
                            <span class="info" v-if="OrderDetailsList.Status == 50">已取消</span>
                        </div>
                        <div class="order-state" v-else>
                            <span class="til">订单状态</span><br>
                            <span class="info" v-if="OrderDetailsList.Status == 10&&OrderDetailsList.NeedPay">等待付款</span>
                            <span class="info" v-if="OrderDetailsList.Status == 10&&!OrderDetailsList.NeedPay">等待预约</span>
                            <span class="info" v-if="OrderDetailsList.Status == 11">预约中</span>
                            <span class="info" v-if="OrderDetailsList.Status == 12">部分预约</span>
                            <span class="info" v-if="OrderDetailsList.Status == 20">已预约</span>
                            <span class="info" v-if="OrderDetailsList.Status == 40">已使用</span>
                            <span class="info" v-if="OrderDetailsList.Status == 50">已取消</span>
                        </div>

                        <div class="pay-state">
                            <span class="til">支付状态</span><br>
                            <span class="info" v-if="OrderDetailsList.PayStatu == 0">{{OrderDetailsList.PayStatuName}}<span v-if="OrderDetailsList.NeedPay" class="go-pay" @click="routerBookComfirm(OrderDetailsList.QGOrderNo)">去支付</span></span>
                            <span class="info" v-else>{{OrderDetailsList.PayStatuName}}</span>
                        </div>
                        <div class="creat-order-date">
                            <br>
                            下单时间：{{OrderDetailsList.CreateDate|dateLong}}
                        </div>
                    </div>
                </div>
                <div class="main">
                    <div class="contact" v-if="OrderDetailsList.PackageType==2">
                        <div class="title">预约号</div>
                        <table>
                            <tbody>
                            <tr v-for="sub,index in OrderDetailsList.SubOrders">
                                <td>{{OrderDetailsList.SubOrders.length>1?'预约号'+(index+1):'预约号'}}</td>
                                <td>
                                   <div class="subCode">
                                        <span>{{sub.Code}}</span>
                                        <span>
                                            <span class='textColor' v-if="sub.OrderUsedStatus==-2" @click="routerBookComfirm(OrderDetailsList.QGOrderNo)">待支付</span>
                                            <span class='textColor' @click="routerReserve(sub.Code,sub.OrderUsedStatus)" v-if="sub.OrderUsedStatus==-1">去预约</span>
                                            <span v-else>{{sub.OrderUsedStatusName}}</span>
                                            <span class="textColor" v-if="sub.MainOrderNo" @click="routerToDetails(sub.MainOrderNo,OrderDetailsList.QGOrderNo,sub.Code)">查看</span>
                                            <span class="textColor" v-if="sub.CanCancel&&!sub.MainOrderNo" @click="cancelOrder(sub,index)">退款</span>
                                        </span>
                                   </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="about">
                        <div class="title">订单详情</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>产品名称</td>
                                <td colspan="3">{{OrderDetailsList.ProductName}}</td>
                            </tr>
                            <tr>
                                <td>产品类型</td>
                                <td colspan="3">{{OrderDetailsList.SKUName}}</td>
                            </tr>
                            <tr>
                                <td>{{OrderDetailsList.PackageType==1?'出发时间':'有效期至'}}</td>
                                <td colspan="3" v-if='OrderDetailsList.PackageType==1'>{{OrderDetailsList.CheckIn|dateToYMDline}}</td>
                                <td colspan="3" v-else>{{OrderDetailsList.EndActiveDate|dateToYMDline}}</td>
                            </tr>
                            <tr v-if="OrderDetailsList.PackageType==2">
                                <td>适用日期</td>
                                <td colspan="3">{{OrderDetailsList.TimeLimitTypeName}}</td>
                            </tr>
                            <tr>
                                <td>特殊要求</td>
                                <td colspan="3">{{OrderDetailsList.SpecialRemark||'无'}}</td>
                            </tr>
                            <tr>
                                <td>可否取消</td>
                                <td v-if="OrderDetailsList.CanCancel&&OrderDetailsList.Token"><span @click="cancelOrder(OrderDetailsList)" class="order-btn" style="font-size: 16px">去取消</span></td>
                                <td v-else>不可取消</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">价格详情</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>价格</td>
                                <td colspan="3">{{OrderDetailsList.Currency}}{{OrderDetailsList.TotalAmount}}</td>
                            </tr>
                            <tr>
                                <td>支付状态</td>
                                <td colspan="3">
                                    <span>{{OrderDetailsList.PayStatuName}}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="contact">
                        <div class="title">客人信息</div>
                        <table>
                            <tbody>
                            <tr v-if="OrderDetailsList.PackageType==1" v-for="item,index in OrderDetailsList.Guests">
                                <td>{{OrderDetailsList.Guests.length>1?'旅客'+(index+1):'旅客'}}</td>
                                <td>{{item.CnName}}</td>
                            </tr>
                            <tr>
                                <td>联系方式</td>
                                <td>{{OrderDetailsList.ReceiverPhone||'无'}}</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                    <div class="contact">
                        <div class="title">产品包含</div>
                        <table>
                            <tbody>
                            <tr>
                                <td>产品包含</td>
                                <td>
                                    <div v-for="item in OrderDetailsList.SkuPieces">{{item}}</div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="seal">
                            <img src="../../assets/img/newydz.png" height="87" width="126"/>
                            <img src="../../assets/img/chapter.png" height="87"/>
                        </div>
                        <div class="print-time">打印时间：{{PrintDate|dateLong}}</div>
                    </div>
                </div>
                <div class="main tips">
                    <div class="contact">
                        <div>
                            郑重提示： 以上优惠价不供网上销售，请告知客人在前台报姓名入住，切勿说出在网上预订，以免出现不能入住的情况！
                            <br>
                            尊敬的客户，您在本社的客户编号为:{{userInfo.CustomerNO}},为了提供更优质快捷的预订服务，在您查询或预订时，请提供您的客户编号，非常感谢您的配合，谢谢！
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="cancel"></Modal>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Modal from './../../common/cmpnt/Modal/modal'

    export default {
        name: "PackageOrderDetails",
        components:{
            Loading,
            Modal
        },
        data: function () {
            return {
                isLoading:false,
                OrderDetailsList:'',
                isPrint:false,
                userInfo: this.dao.get('userInfo'),
                PrintDate:new Date(),
                roomTotalAmount:0,
                RoomPrice:0,
                SurchargesPrice:0,
                SurchargesShow:false,
                qr:'',
                modal:{
                    show:false,
                    config:{}
                },
                cancelToken:'',
            }
        },
        created() {

        },
        mounted() {
            var that = this
            document.title='【'+this.$route.params.orderNO+'】'+'订单详情';
            that.initData();
            // this.getQR()
            that.printDate();
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                    that.$zh_tran(localStorage.getItem('lang'))
                }         
            })
        },
        methods: {
            routerToDetails(id,qg,code){
                window.open('#/reserveDetails?OrderNO='+id+'&QGOrderNo='+qg+'&Code='+code, '_blank')
            },
            cancel(){
                var that = this;
                that.modal.show = false;
                that.isLoading = true;

                that.postRequest({
                    url: that.Api.cancelPackageOrder,
                    params: that.cancelToken
                }).then(res => {
                    if (res.IsSuccess) {
                        that.initData()
                    } else {
                        that.error({title: '提示', content: res.Msg || '取消失败'});
                    }
                });
            },
            getQR(){
                var that = this;
                that.getRequest({
                    url: that.Api.qr+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    if (res && res.IsSuccess) {
                        that.qr = 'data:image/jpg;base64,'+ res.Result
                    } else {
                        // $state.complete();
                    }
                });
            },
        
            printDate(){
                var that = this;
                var i = setInterval(function () {
                    that.PrintDate = new Date()
                },1000)
            },
            routerBookComfirm(orderNO){
                var that = this;
                var time = Date.parse(new Date())
                that.$router.push('/packageBookComfirm?OrderNO='+orderNO+'&time='+time)

            },
            routerReserve(code,status){
                if(status!=-1)return
                this.dao.set("ReserveData", JSON.stringify(this.OrderDetailsList));
                this.$router.push('/packageReserve?Code='+code)
            },
            cancelOrder(item,index){
                if(!item){
                    return
                }
                var that = this;
                var params = ''
                var token = ''
                var code = ''
                var text = ''
                if(index>=0){
                    token = that.OrderDetailsList.SubOrders[index].Token;
                    code = that.OrderDetailsList.SubOrders[index].Code;
                    text = '确定要取消预约号为:"' + code + '"的订单吗?'
                    params = {
                        Token:token,
                        Code:code
                    }
                }else {
                    
                    token = that.OrderDetailsList.Token;
                    code = that.$route.params.orderNO;
                    text = '确定要取消订单号为:"' + code + '"的订单吗?'
                    params = {
                        Token:token
                    }
                }
                that.cancelToken = params

                that.modal={
                    show:true,
                    content: text,
                    yes:'确定',
                    no:'取消',
                    isComfirm:true
                }
            },
            printBtn(){
                this.isPoint = true;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'none'
                let subOutputRankPrint = document.getElementById('subOutputRank-print1');
                let newContent =subOutputRankPrint.innerHTML;
                let oldContent = document.body.innerHTML;
                document.body.innerHTML = newContent;
                window.print();
                window.location.reload();
                document.body.innerHTML = oldContent;
                document.getElementsByClassName('to-print-btn')[0].style.display = 'block'
                this.isPoint = false;
                return false;
            },
            initData(){
                var that = this;
                that.isLoading = true;
                that.getRequest({
                    url: that.Api.getPackageOrderDetails+'?orderNO='+that.$route.params.orderNO,
                    params: ''
                }).then(res => {
                    that.isLoading = false;
                    if (res && res.IsSuccess) {
                        that.OrderDetailsList = res.Result
                        that.OrderDetailsList.TotalAmount = that.OrderDetailsList.TotalAmount.toFixed(2);
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }        
                        })
                    } else {
                        // $state.complete();
                    }
                });
            },
        }
    }
</script>
<style scoped>
.subCode {
    display: flex;
    justify-content: space-between;
    align-items: center
}

.subCode span{
    padding-left: 20px;
    
}

.subCode .textColor {
    color: #00a0e9;
    cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/package/orderDetails.vue